import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';
import { CompositeMatchingParams, CompositeMatchingResponse } from 'src/types/compositeMatching';
import { isAuthorizedQuery } from 'src/selectors/isAuthorizedQuery';
import { queryCompositeMatching, QUERY_KEY, CompositeMatchingQueryKey } from 'src/queries/queryCompositeMatching';

export const buildCompositeMatchingQueryKey = (
    accessToken: string | undefined | false,
    params: CompositeMatchingParams,
): CompositeMatchingQueryKey => [QUERY_KEY, accessToken, params];

export const useQueryCompositeMatching = (
    params: CompositeMatchingParams | null,
): UseQueryResult<CompositeMatchingResponse, Error> => {
    const accessToken = useRecoilValue(isAuthorizedQuery);

    return useQuery<CompositeMatchingResponse, Error, CompositeMatchingResponse, CompositeMatchingQueryKey>(
        buildCompositeMatchingQueryKey(accessToken, params ?? ({} as CompositeMatchingParams)),
        queryCompositeMatching,
        {
            enabled: !!params && !!accessToken,
            refetchOnWindowFocus: false,
            retry: false,
            suspense: false,
        },
    );
};
